import Card from "../Card";
import CircularProgress from "@mui/material/CircularProgress";

import axios from "axios";
import { useEffect, useState } from "react";

const key = "b55d580200c51623fe9608f8f064a09b";

const ResultsByGenre = ({ genreId }) => {
  const [moviesByGenre, setMoviesByGenre] = useState("");
  const [genrePageToShow, setGenrePageToShow] = useState("");

  const getMoviesByGenre = async () => {
    const response = await axios.get(
      `https://api.themoviedb.org/3/discover/movie?api_key=${key}&with_genres=${genreId}&page=${genrePageToShow}&language=en-US`
    );
    setMoviesByGenre(response.data.results);
  };

  useEffect(() => {
    setGenrePageToShow(1);
    getMoviesByGenre();
  }, [genreId]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getMoviesByGenre();
  }, [genrePageToShow]);

  return (
    <div className="movies-container my-3 pb-4 container-fluid">
      <div className="paginationDiv mb-3">
        <div className="pagination p-2">
          {/*  */}
          <div
            className="prevPage"
            onClick={() => {
              setGenrePageToShow((prevState) => {
                if (prevState === 1) {
                  return 1;
                }
                setMoviesByGenre("");
                return prevState - 1;
              });
            }}
          >
            <i className="fa-solid fa-play my-1"></i>
          </div>

          <div
            className="nextPage"
            onClick={() => {
              setGenrePageToShow((prevState) => {
                if (moviesByGenre.length === 0) {
                  return prevState;
                }
                setMoviesByGenre("");
                return prevState + 1;
              });
            }}
          >
            <i className="fa-solid fa-play my-1"></i>
          </div>
        </div>
      </div>

      {moviesByGenre ? (
        <>
          {moviesByGenre.map((movie) => (
            <div className="loaderContainer__search ">
              <Card movie={movie} key={movie.id} type="loader_results" />
            </div>
          ))}
          <div className="paginationDiv mt-3">
            <div className="pagination p-2">
              {/*  */}
              <div
                className="prevPage"
                onClick={() => {
                  setGenrePageToShow((prevState) => {
                    if (prevState === 1) {
                      return 1;
                    }
                    setMoviesByGenre("");
                    return prevState - 1;
                  });
                }}
              >
                <i className="fa-solid fa-play my-1"></i>
              </div>

              <div
                className="nextPage"
                onClick={() => {
                  setGenrePageToShow((prevState) => {
                    if (moviesByGenre.length === 0) {
                      return prevState;
                    }
                    setMoviesByGenre("");
                    return prevState + 1;
                  });
                }}
              >
                <i className="fa-solid fa-play my-1"></i>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ width: "100%", height: "67vh" }}
        >
          <CircularProgress color="secondary" />
        </div>
      )}
    </div>
  );
};

export default ResultsByGenre;
